const GA_MEASUREMENT_ID = 'G-Z9ZWF4EFWB';

export const CONSENT_STORAGE_KEY = 'petcart_cookie_consent';

let analyticsLoaded = false;

export const getStoredConsent = () => {
  try {
    const raw = localStorage.getItem(CONSENT_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed?.analytics === true ? 'accepted' : parsed?.analytics === false ? 'declined' : null;
  } catch {
    return null;
  }
};

export const storeConsent = (accepted) => {
  localStorage.setItem(
    CONSENT_STORAGE_KEY,
    JSON.stringify({
      analytics: accepted,
      updatedAt: new Date().toISOString(),
    }),
  );
};

const ensureGtag = () => {
  window.dataLayer = window.dataLayer || [];
  window.gtag =
    window.gtag ||
    function gtag() {
      window.dataLayer.push(arguments);
    };
};

export const updateGoogleConsent = (granted) => {
  ensureGtag();
  const value = granted ? 'granted' : 'denied';
  window.gtag('consent', 'update', {
    ad_storage: value,
    ad_user_data: value,
    ad_personalization: value,
    analytics_storage: value,
  });
};

export const trackLeadConversion = (source) => {
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'generate_lead',
      lead_source: source || 'unknown',
    });
  } catch {
    // Tracking must never break the site
  }
};

const loadScript = (src, attrs = {}) =>
  new Promise((resolve, reject) => {
    if (document.querySelector(`script[src="${src}"]`)) {
      resolve();
      return;
    }
    const script = document.createElement('script');
    script.src = src;
    script.async = true;
    Object.entries(attrs).forEach(([key, value]) => {
      script.setAttribute(key, value);
    });
    script.onload = () => resolve();
    script.onerror = () => reject(new Error(`Failed to load ${src}`));
    document.head.appendChild(script);
  });

const initGoogleAnalytics = async () => {
  ensureGtag();
  window.gtag('js', new Date());
  window.gtag('config', GA_MEASUREMENT_ID, { anonymize_ip: true });
  await loadScript(`https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`);
};

export const enableAnalytics = async () => {
  updateGoogleConsent(true);
  if (analyticsLoaded) return;
  analyticsLoaded = true;
  try {
    await initGoogleAnalytics();
  } catch {
    // Analytics must never break the site
  }
};

export const disableAnalytics = () => {
  updateGoogleConsent(false);
};
